// TODO: Should be able to clean up with nin-save-filter-dialog-entry-point
import type { OperationModalProps } from '@atlassian/jira-directory-base/src/model/index.tsx';
import type { Filter } from '@atlassian/jira-filters-common/src/model/index.tsx';
import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import { AsyncUpdateFilterDialog as UpdateFilterDialog } from '@atlassian/jira-save-filter-dialog/src/ui/update-filter-dialog/async.tsx';
import type { OperationData } from '@atlassian/jira-shareable-entity-dialog/src/model/types.tsx';
import type { State } from '../../../state/types.tsx';

const mapStateToPropsNewModal = (initialState: State, ownProps: OperationModalProps<Filter>) => {
	const onEdited = (_updatedData: OperationData) => {
		// @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
		ownProps.onUpdated();
	};

	return () => ({
		onDialogShown: ownProps.onDialogShown,
		filterId: ownProps.entityId,
		onClose: ownProps.onCancel,
		onSuccess: onEdited,
		// onEditFailed: noop, // do NOT send .onUpdateFailed() - it will remove operation from `operations` array, even though modal is still open
		isOpen: true,
	});
};

const FilterDialog = UpdateFilterDialog;
const mapStateToProps = mapStateToPropsNewModal;

export default connect(mapStateToProps, {})(FilterDialog);
